module.exports = __webpack_public_path__ + "97f2c2f80663e4c2589a8a3abbb53c5d.MP3";